import React, { useState, useEffect } from "react";
import axios from "axios";
import Nav from "./Nav";

const BlogPage = () => {
  const [blogPosts, setBlogPosts] = useState([]);

  // Fetch blog posts from the Ghost API
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(
          "https://pressrequest.ghost.io/ghost/api/content/posts/",
          {
            params: {
              key: "e9fe6a7eb33c6e005a1e6544da",
              fields: "title,excerpt,slug,published_at, feature_image",
              include: "authors",
            },
          }
        );

     // Transform API response into the required format
const formattedPosts = response.data.posts.map((post) => {
    console.log("Post Data:", post); // Log the raw post object to inspect its structure
  
    return {
      id: post.id,
      title: post.title,
      excerpt: post.excerpt,
      author: post.primary_author ? post.primary_author.name : "Unknown",
      date: new Date(post.published_at).toLocaleDateString(),
      imageUrl: post.feature_image || "https://via.placeholder.com/300", // Use a placeholder if no image is available
      slug: post.slug,
    };
  });
        console.log(formattedPosts)
        setBlogPosts(formattedPosts);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="dashboard-container">
        <div className="container mx-auto">
        <Nav/>
        <h1 className="text-4xl font-bold mb-8 text-center">Blog</h1>
        <div className="flex flex-col space-y-6">
            {blogPosts.map((post) => (
                <div
                    key={post.id}
                    className="flex flex-col md:flex-row bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 overflow-hidden h-full"
                 >
                    <img
                        className="w-full md:w-48 lg:min-h-full object-cover"
                        src={
                            post.slug === "haro-shutdown-changes-journalism"
                            ? "https://i.imgur.com/LJZyomX.jpeg"
                            : post.imageUrl // Use imageUrl consistently
                        }
                        alt={post.title}
                        />

                    <div className="p-5 flex flex-col justify-between w-full">
                        <div>
                        <a
                            href={`/blog/${post.slug}`}
                            className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white hover:underline"
                        >
                            {post.title}
                        </a>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                            {post.excerpt}
                        </p>
                        </div>
                        <div className="flex justify-between items-center">
                        <div>
                            <span className="text-sm text-gray-500 dark:text-gray-400">
                            {post.author}
                            </span>
                            <span className="text-sm text-gray-500 dark:text-gray-400 ml-4">
                            {post.date}
                            </span>
                        </div>
                        <a
                            href={`/blog/${post.slug}`}
                            className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                            Read more
                            <svg
                            aria-hidden="true"
                            className="w-4 h-4 ml-2 -mr-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                fillRule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            ></path>
                            </svg>
                        </a>
                        </div>
                    </div>
                </div>     
            ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
